<template>
  <div class="main-content">
    <!-- begin our story section -->

    <section class="bg-white story">
      <div class="container">
        <div class="headline text-center">
          <div class="row">
            <div class="col-md-6 col-md-offset-3">
              <h2 class="section-title">Our Story</h2>
            </div>
          </div>
        </div>
        <!-- /.headline -->

        <div class="row">
          <div class="col-md-10 col-md-offset-1 text-center">
            <p class="story-description">
              <b>DIGIPROD</b> was born from a passion for technology and
              innovation, combining over 15 years of experience in software
              development, process automation, infrastructure, and scalable web
              solutions.
            </p>
            <p class="story-description">
              Our founder began his journey as a full-stack developer, working
              on various projects focused on REST APIs, web systems, automated
              testing, and cloud infrastructure. With expertise in languages
              like JavaScript, Python, PHP, and solid experience with services
              like AWS, Docker, Jenkins, and managed databases, we create modern
              and robust technological solutions.
            </p>
            <p class="story-description">
              Today, <b>DIGIPROD</b> operates as an on-demand service platform
              for small and medium-sized businesses, delivering personalized
              digital solutions that include complete websites, mobile
              applications, marketing automation, artificial intelligence
              implementation, and cloud infrastructure management.
            </p>
            <!-- /.story-description -->
          </div>
        </div>
      </div>
    </section>
    <!-- end of our story section -->
  </div>
  <!-- end of /.main-content -->
</template>

<script>
export default {
  name: "AboutMainContent",
};
</script>
